(() => {
 const cache = new Map();
 async function loadOptions(path) {
  if (!cache.has(path)) {
   const request = new URL(path, location.origin);
   request.search = '';
   request.searchParams.set('section_id', 'navigation-filter-options');
   const preview = new URL(location.href).searchParams.get('preview_theme_id');
   if (preview) request.searchParams.set('preview_theme_id', preview);
   cache.set(path, fetch(request).then(async response => {
    if (!response.ok) throw new Error('Navigation filter request failed');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = doc.querySelector('[data-navigation-filter-options]');
    if (!data) throw new Error('Navigation filter data unavailable');
    return JSON.parse(data.textContent);
   }).catch(error => { cache.delete(path); throw error; }));
  }
  return cache.get(path);
 }
 async function hydrate(column) {
  if (column.dataset.loading || column.dataset.loaded) return;
  column.dataset.loading = 'true';
  try {
   const filters = await loadOptions(column.dataset.collectionUrl);
   const key = {length:'skirt-dress-length', fabric:'fabric', sleeve:'sleeve-length'}[column.dataset.scopedMenuFilter];
   const filter = filters.find(item => item.param.includes(key));
   const values = (filter?.values || []).filter(value => value.count > 0).slice(0, Number(column.dataset.itemLimit) || 6);
   const fragment = document.createDocumentFragment();
   values.forEach(value => {
    const link = document.createElement('a');
    const url = new URL(column.dataset.collectionUrl, location.origin);
    url.searchParams.set('quick_entry','attribute');
    url.searchParams.set(filter.param,value.value);
    link.href = url.href;
    link.textContent = value.label === 'Short' && column.dataset.scopedMenuFilter === 'sleeve' ? 'Short Sleeve' : value.label === 'Knee' ? 'Knee Length' : value.label;
    fragment.append(link);
   });
   if (values.length) column.replaceChildren(fragment);
   column.dataset.loaded = 'true';
  } catch {
   // Keep the collection link available; retry when the menu is opened again.
  } finally { delete column.dataset.loading; }
 }
 function init(root = document) {
  root.querySelectorAll('[data-scoped-menu-filter]').forEach(column => {
   if (column.dataset.observed) return;
   column.dataset.observed = 'true';
   const observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) hydrate(column);
   });
   observer.observe(column);
   const panel = column.closest('[data-nav-disclosure], [data-mobile-panel]');
   panel?.addEventListener('pointerenter', () => hydrate(column));
   panel?.addEventListener('focusin', () => hydrate(column));
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
 else init();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
